import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Table } from "../table/Table";
import { BodyTableOrderLogs } from "./BodyTableOrderLogs";

type TableOrderProps = {
    orderDetail: any;
};

export const TableOredrLogs = ({
    orderDetail
}: TableOrderProps): JSX.Element => {
    const { t } = useTranslation();
    const i18nOrdersTableLogs = (key: string): string =>
        t(`orders-directory.tableOrderLogs.header.${key}`);

    const columns = [
        {
            id: "created_stamp",
            label: i18nOrdersTableLogs("created-stamp"),
        },
        {
            id: "current_status",
            label: i18nOrdersTableLogs("current-status"),
        },
        {
            id: "previous_status",
            label: i18nOrdersTableLogs("previous-status"),
        },
        {
            id: "order_changed",
            label: i18nOrdersTableLogs("order-changed"),
        }
    ];

    return (
        <div className="relative mt-4">
            <Table columns={columns}>
                <BodyTableOrderLogs
                    orderDetail={orderDetail}
                />
            </Table>
        </div>
    );
};
